import styled, { css } from 'styled-components';
import { Box } from '@bechtel/gds';

export const WelderStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  mt: { sm: '450' },
  pt: { sm: '450' },
  pl: { sm: '500' },
  pr: { sm: '450' },
  mr: { sm: '450' },
  pb: { sm: '600' },
  flexBasis: { sm: '50%' },
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.grey[100]};
    border-radius: ${theme.radii[200]};
  `};
`;

export const StencilSelectorStyled = styled(Box).attrs({
  mt: { sm: '500' },
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
  `};
`;
